import { render, staticRenderFns } from "./FormCustomCheckboxField.vue?vue&type=template&id=0fd5c77b&"
import script from "./FormCustomCheckboxField.vue?vue&type=script&lang=js&"
export * from "./FormCustomCheckboxField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports